import IconArrowSteps from './iconArrowSteps';

export default IconArrowSteps;
